<script setup lang="ts">
import { useEventSettings } from '@desktop/views/Relation/composables'
import AssignPlayerOnPitchOverlay from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/AssignPlayerOnPitchOverlay/AssignPlayerOnPitchOverlay.vue'
import Pitch from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/Pitch/Pitch.vue'

import PitchWithoutBenchSvg from './pitch-without-bench.svg'
import PossessionAwaySvg from './possession-away.svg'
import PossessionHomeSvg from './possession-home.svg'

const { eventSettings } = useEventSettings()
</script>

<template>
  <!-- 
    pitchImageClass="max-h-[calc(100vh-38rem)]

    38rem is arbitrary value that ensures the pitch ends exactly at the bottom of the layout container,
    and when window height is decreasing, pitch smoothly adapts to the new viewport height.
   -->
  <Pitch
    class="flex w-1/2 p-1.5 lg:p-2"
    :pitchImageSrc="PitchWithoutBenchSvg"
    pitchImageClass="max-h-[calc(100vh-38rem)] min-h-25"
    :possessionHomeSrc="PossessionHomeSvg"
    :possessionAwaySrc="PossessionAwaySvg"
  >
    <template #overlays>
      <AssignPlayerOnPitchOverlay v-if="eventSettings.assignPlayerOnPitch" />
    </template>
  </Pitch>
</template>
